export const SYNC_NOTIFICATIONS_BADGE = 'SYNC_NOTIFICATIONS_BADGE' as const
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS' as const
export const GET_NEXT_NOTIFICATIONS = 'GET_NEXT_NOTIFICATIONS' as const
export const GET_NOTIFICATIONS_SUCCEEDED = 'GET_NOTIFICATIONS_SUCCEEDED' as const
